const WELL_RANKING_LIST_ITEM_TEST_IDS = {
  AD: 'well-ranking-list-item-ad',
  DESCRIPTION: 'well-ranking-list-item-description',
  HIGHLIGHTED_STATS: 'well-ranking-item-list-highlighted-stats',
  IMAGE: 'well-ranking-list-item-image',
  NEXT: 'well-ranking-list-item-pagination-next',
  PREVIOUS: 'well-ranking-list-item-pagination-previous',
  TABLE_ROW: 'well-ranking-list-item-table-row',
  TITLE: 'well-ranking-list-item-title',
};

export type TestIds = {
  [key in keyof typeof WELL_RANKING_LIST_ITEM_TEST_IDS]?: string;
};

const getWellRankingListItemTestId = (value: keyof TestIds) => WELL_RANKING_LIST_ITEM_TEST_IDS[value];

export default getWellRankingListItemTestId;
